import styled from 'styled-components';
import {
  mixin, zIndexValues,
} from 'shared/utils/styles';

export const Container = styled.aside`
  grid-area: snav;
  height: calc(100vh + 10px);
  background-color: rgb(51, 51, 51);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 50px;
  z-index: ${zIndexValues.navLeft};
  position: fixed;
  top: 0;
  left: 0;
  overflow-x: hidden;
  width:50px;
  transition: all 0.1s;
  ${mixin.hardwareAccelerate}
  &:hover {
    width: 200px;
    box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.6);
  }
`;

export default Container;
